import config from '../config/config'

/**
 * Auth route names for WorkOS authentication
 */
type AuthRoute =
  | 'sign-in'
  | 'check-session'
  | 'sign-out'
  | 'reset-password'
  | 'confirm-reset-password'
  | 'accept-invitation'
  | 'accept-membership-invite'
  | 'membership-invite'
  | 'resend-membership-invite'
  | 'magic-auth/send-code'
  | 'magic-auth/verify-code'
  | 'organization-selection'
  | 'select-organization'
  | 'switch-organization'

/**
 * Generates the auth API route for WorkOS authentication.
 *
 * @param route - The auth route name (e.g., 'sign-in', 'accept-invitation')
 * @returns The full API URL path
 *
 * @example
 * getAuthRoute('sign-in') // '/api/v1/unauthenticated/auth/workos/sign-in'
 */
export const getAuthRoute = (route: AuthRoute): string => {
  const baseUrl = `${config.apiUrl}/unauthenticated/auth`
  return `${baseUrl}/workos/${route}`
}
